/* eslint-disable no-undef */
import Helmet from "react-helmet"
import React, { useEffect, useState, useContext } from "react"
import classnames from "classnames"

import { useTicketsPage } from "~queries/hooks"

/* Import Global Context(s) */
import LocationContext from "~context/currentLocation"

/* Import Global Component(s) */
import Page from "~components/page/page"
import PageHeader from "~components/page/components/pageHeader/pageHeader"
import PageArticle from "~components/page/components/pageArticle/pageArticle"
import PageArticleSection from "~components/page/components/pageArticle/components/pageArticleSection/pageArticleSection"
import BlockContent from "~components/blockContent/blockContent"
import LocationNav from '~components/location/location'

/* Import Local Component(s) */
import TicketsHeader from "./components/ticketsHeader/ticketsHeader"

/* Import Local Style(s) */
// import "./squad-up-bootstrap.scss"
// import "./squad-custom-up.scss"

import "./bootstrap-namespace.min.css"
import "./squadup-custom.scss"

const SquadUp = ({ location }) => {

  const { _rawHeaderCopy, showMiamiBeach, showHouston } = useTicketsPage()


  const [cL] = useContext(LocationContext)

  const currentLocation = cL.activeLocation

  useEffect(() => {

    const initWidget = (showHouston = false, showMiamiBeach = false) => {

      let userIds = []
      let topics = []


      if (showHouston && showMiamiBeach) {
        // use currentLocation to determine widget

        if (currentLocation == 'miamiBeach') {
          userIds.push(5385987)
          topics.push("UntitledMB")
          console.log('switching to MB')
        } else if (currentLocation == 'houston') {
          userIds.push(9798123)
          topics.push("UntitledHOU")
          console.log('switching to HOU')
        }

      } else if (showHouston) {
        userIds.push(9798123)
        topics.push("UntitledHOU")
      } else if (showMiamiBeach) {
        userIds.push(5385987)
        topics.push("UntitledMB")
      }


      console.log(window.SquadupCheckoutAPI, window.SquadupCheckoutAPI)

      if (
        window.SquadupCheckoutAPI &&
        typeof window.SquadupCheckoutAPI.create === "function"
      ) {

        const squadupVals = {
          title: "SquadUP Events",
          image: "https://s3.amazonaws.com/squadup_production/users/logos/005/385/987/original/1_Host_Logo_%281%29.png?1723670538",
          root: "squadup-checkout",
          userId: userIds,
          title: "Please select your ticket from the options below:",
          shoppingCartEnabled: false,
          brandingPosition: "none",
          ticketGuardianEnabled: false,
          // autoScrollElementId: showHouston && showMiamiBeach ? "location_header" : "squadup-checkout",
          topics: topics,
          flyerList: true,
          descriptionEnabled: true,
          onDomReady: true,
        }


        window.SquadupConfig.setValues(squadupVals);

        window.SquadupCheckoutAPI.create("squadup-checkout", {});

        console.log('success')
      } else {
        console.log('retrying')
        setTimeout(() => {
          initWidget(showHouston, showMiamiBeach)
        }, 250); // Retry after 250ms if SquadupCheckoutAPI is not ready
      }
    };

    initWidget(showHouston, showMiamiBeach);

    return () => {
      if (
        window.SquadupCheckoutAPI &&
        typeof window.SquadupCheckoutAPI.destroy === "function"
      ) {
        window.SquadupCheckoutAPI.destroy("squadup-checkout");
      }
    };
  }, [showHouston, showMiamiBeach, currentLocation]);



  return (
    <>
      {/*
        src="https://embed.squadup.com/main-v2.5-beta-1.min.js"

        src="https://embed.squadup.com/main-v2.min.js"
      */}
      <Helmet>
        <script
          src="https://embed.squadup.com/main-v2.5-beta-2.min.js"
          type="text/javascript"
        />

        {/*begin olark code*/}
        <script
          type="text/javascript"
          async
          dangerouslySetInnerHTML={{
            __html: `;(function(o,l,a,r,k,y){if(o.olark)return; r="script";y=l.createElement(r);y.setAttribute("id","olarkscript");r=l.querySelector("#olarkscript"); y.async=1;y.src="//"+a;r.parentNode.insertBefore(y,r); y=o.olark=function(){k.s.push(arguments);k.t.push(+new Date)}; y.extend=function(i,j){y("extend",i,j)}; y.identify=function(i){y("identify",k.i=i)}; y.configure=function(i,j){y("configure",i,j);k.c[i]=j}; k=y._={s:[],t:[+new Date],c:{},l:a}; })(window,document,"static.olark.com/jsclient/loader.js");
              /* custom configuration goes here (www.olark.com/documentation) */
              olark.identify('6594-642-10-9959');
              /* Add configuration calls below this comment */
              olark.identify('6594-642-10-9959');
              olark.configure('system.hb_primary_color', '#000000');`
          }}
        ></script>
        {/*end olark code*/}
      </Helmet>

      <Page title="Tickets" location={location}>



        <PageHeader title="Tickets" location={location} />
        <PageArticle title="Tickets" className="tickets">

          {showMiamiBeach && showHouston && <LocationNav />}

          <PageArticleSection className="tickets_intro font-size--small">
            <div className="section_inset mb--1">
              <BlockContent blocks={_rawHeaderCopy ? _rawHeaderCopy : []} />
            </div>
          </PageArticleSection>

          <PageArticleSection className="tickets">
            <div className={classnames("squadup-checkout-app")}>
              <div id="squadup-checkout"></div>
            </div>
          </PageArticleSection>
        </PageArticle>
      </Page>
    </>
  )
}

export default SquadUp
